<template>
  <div
    v-if="(['EXPIRED', 'DISCUSSING', 'CLOSED'].indexOf(request.status) > -1 && requestParticipants.length > 0 && !(request.requestType === 'PQT' && request.autoWinner === 1))"
    class="card"
  >
    <div class="card-header">
      <h4 class="mb-0">
        {{ $t('requestParticipants.itiraklar') }}
      </h4>
    </div>
    <div class="card-body">
      <div
        v-if="userToStartConversation"
        class="mb-3 text-center"
      >
        <p
          v-if="request.requestType==='REV'"
          class="lead"
        >
          {{ $t('requestParticipants.itirakNAaQiymtVerdi', {userOrder: userToStartConversation.userOrder}) }}
        </p>
        <p
          v-else-if="request.requestType==='AUC'"
          class="lead"
        >
          {{ $t('requestParticipants.itirakUsertostartconversationuserorderNYkskQiymtiV', {user:userToStartConversation.userOrder}) }}
        </p>
        <p
          v-else-if="request.requestType==='PQT'"
          class="lead"
        >
          {{ $t('requestParticipants.itirakUsertostartconversationuserorderNUyunQiymtiV', {user:userToStartConversation.userOrder}) }}
        </p>
        <a
          class="btn btn-lg btn-outline-primary"
          @click.prevent="startAuctionConversation"
        >
          {{ $t('requestParticipants.itirakIlMzakiryBala', {userOrder: userToStartConversation.userOrder}) }}
        </a>
      </div>


      <div>
        <div
          v-for="(p,i) in requestParticipants"
          :key="i"
          class="row lead"
        >
          <div class="col-sm-6 lead">
            <strong class="badge bg-primary">{{ $t('requestParticipants.itirak') }} #{{ p.userOrder }}</strong>
          </div>
          <div class=" col-sm-6 text-right">
            {{ $t('requestParticipants.azn', {lastPrice: p.lastPrice}) }}
          </div>
          <div class="col-12 font-weight-bold border-bottom-dark">
            <span v-if="p.userStatus ==='NEW'">{{ $t('requestParticipants.itirak') }}</span>
            <span v-if="p.userStatus ==='BLOCKED'">{{ $t('requestParticipants.bloklanm') }}</span>
            <span v-if="p.userStatus ==='WINNER'">{{ $t('purchases.qalib') }}</span>
            <span v-if="p.userStatus ==='DISCUSSING'">{{ $t('requestItem.mzakirGedir') }}</span>
            <span v-if="p.userStatus ==='UNSUCCESS'">{{ $t('requestParticipants.baTutmayanTklif') }}</span>
            <span
              v-if="p.userStatus ==='UNSUCCESS'"
              class="text-danger"
            >
              : {{ p.rejectReason }}
            </span>
            <hr>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getRequestParticipants,
  startAuctionConversation,
  startOfferConversation
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";

export default {
  name: 'RequestParticipants',
  props: {
    request: {},
    isMyRequest: {},
  },
  data() {
    return {
      requestParticipants: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    userToStartConversation() {

      let user = null;
      if (this.isMyRequest) {
        for (const element of this.requestParticipants) {
          let p = element;
          if (p.userStatus === 'NEW') {
            user = p;
            break;
          }
          if (p.userStatus === 'WINNER' || p.userStatus === 'DISCUSSING') {
            break;
          }
        }
      }
      return user;
    }
  },
  mounted() {
    getRequestParticipants(this.token, this.request.id).then(list => {
      this.requestParticipants = list;
    })
  },
  methods: {

    startAuctionConversation() {

      if(this.request.requestType==='PQT'){
        startOfferConversation(this.token, this.request.id).then(data => {
          if (data.code === 200) {
            this.$router.push(`/dashboard/conversation/${data.id}`);
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        });
      } else {

        startAuctionConversation(this.token, this.request.id).then(data => {
          if (data.code === 200) {
            this.$router.push(`/dashboard/conversation/${data.id}`);
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        });
      }
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
